import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { WidgetComponent } from 'app/widget/widgets/widget-component';
import { Subscription } from 'rxjs';
import { StoreService } from 'core/services';
import { UtilsWidgetService } from '../services/utils-widget.service';

@Component({
  selector: 'lms-active-students-widget',
  templateUrl: './active-students-widget.component.html',
  styleUrls: ['./active-students-widget.component.scss']
})
export class ActiveStudentsWidgetComponent implements WidgetComponent, OnInit, OnDestroy {
  @Input() totals: any;
  @Input() data: any;
  @Input() key?: string;

  public studentsStatusKeys = ['inactive', 'active'];
  public legendColors: any[] = ['color-game-12', 'color-game-8'];
  public tooltipLabels: string[] = [];
  public chartColors: { backgroundColor: string[] } = {
    backgroundColor: ['#66b2ff', '#007eff']
  };
  public tooltipText: string;
  public chartOptions = { height: 150 };
  private tooltipSubscription: Subscription = new Subscription();

  constructor(private translateService: TranslateService) {}

  ngOnInit(): void {
    this.tooltipLabels = [
      this.translateService.instant('groups.dashboard.legend.inactive'),
      this.translateService.instant('groups.dashboard.legend.active')
    ];

    this.tooltipSubscription = StoreService.get(this.data.action).subscribe((tooltipObject) => {
      this.tooltipText = UtilsWidgetService.containTooltip(tooltipObject, this.data.action, this.key);
    });
  }

  ngOnDestroy(): void {
    this.tooltipSubscription.unsubscribe();
  }
}
